import clsx from 'clsx'

import styles from './skeleton.module.scss'

export interface ISkeletonProps {
    animation?: boolean
    borderRadius?: number
    children?: React.ReactNode
    className?: string
    count?: number
    direction?: 'column' | 'row'
    gap?: number
    height?: number | string
    isLoading?: boolean
    width?: number | string
}

interface ISkeletonItemProps {
    animation: boolean
    borderRadius?: number
    className?: string
    height?: number | string
    width?: number | string
}

const SkeletonItem = ({
    width,
    height = 'auto',
    borderRadius,
    animation,
    className,
}: ISkeletonItemProps): React.ReactNode => {
    const style: React.CSSProperties = {}

    if (width) {
        style.width = typeof width === 'number' ? `${width}px` : width
    }
    if (height) {
        style.height = typeof height === 'number' ? `${height}px` : height
    }
    if (borderRadius !== undefined) {
        style.borderRadius = `${borderRadius}px`
    }

    return (
        <div
            className={clsx(styles.skeleton, animation && styles['skeleton_animated'], className)}
            style={style}
        />
    )
}

export const Skeleton = ({
    width,
    height = 'auto',
    borderRadius,
    animation = true,
    count = 1,
    direction = 'column',
    gap,
    className,
    isLoading,
    children,
}: ISkeletonProps): React.ReactNode => {
    if (isLoading) {
        return count === 1 ?
                <SkeletonItem
                    animation={animation}
                    borderRadius={borderRadius}
                    className={className}
                    height={height}
                    width={width}
                />
            :   <div
                    className={styles.skeleton__container}
                    style={{
                        flexDirection: direction,
                        gap: gap ? `${gap}px` : undefined,
                    }}
                >
                    {Array.from({ length: count }, (_, index) => (
                        <SkeletonItem
                            key={index}
                            animation={animation}
                            borderRadius={borderRadius}
                            className={className}
                            height={height}
                            width={width}
                        />
                    ))}
                </div>
    }

    return <>{children}</>
}
